<section class="catalog-map-section" data-testid="catalog-map-section">
  <!-- Top right above the map, label switching with the state (#172 mockup A/B). A real button
       with aria-expanded: the list below stays the full-value view, the map is the extra. -->
  <div class="d-flex justify-content-end mb-2">
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm"
      (click)="toggle()"
      [attr.aria-expanded]="visible()"
      aria-controls="catalog-map"
      data-testid="catalog-map-toggle"
    >
      @if (visible()) {
        <span i18n="@@catalogMap.hide">Karte ausblenden</span>
      } @else {
        <span i18n="@@catalogMap.show">Karte anzeigen</span>
      }
    </button>
  </div>

  <!-- The container stays in the DOM while collapsed (hidden, no map inside), so the map can be
       mounted from a lifecycle hook rather than chased with a view query. -->
  <div class="catalog-map-frame" [class.d-none]="!visible()">
    <div
      #mapContainer
      id="catalog-map"
      class="catalog-map"
      role="application"
      i18n-aria-label="@@catalogMap.ariaLabel"
      aria-label="Karte der Anbieter"
      [attr.data-testid]="visible() ? 'catalog-map' : null"
    ></div>
    @if (loading()) {
      <div class="catalog-map-loading" aria-hidden="true">
        <span class="spinner-border spinner-border-sm"></span>
      </div>
    }
  </div>

  @if (visible()) {
    <!-- The line that makes the viewport search explainable at all (mockup assertion 5). -->
    <p class="small text-muted mt-2 mb-0" aria-live="polite" data-testid="catalog-map-hint">
      @if (failed()) {
        <span i18n="@@catalogMap.failed">Die Anbieter konnten für die Karte nicht geladen werden.</span>
      } @else if (truncated()) {
        <span i18n="@@catalogMap.truncated">
          {{ sellerCount() }} Anbieter, davon {{ maxPins }} auf der Karte – bitte den Bereich eingrenzen (näher heranzoomen).
        </span>
      } @else if (mode() === 'viewport') {
        <span i18n="@@catalogMap.sellersInViewport">{{ sellerCount() }} Anbieter im Kartenausschnitt · Karte bewegen sucht neu</span>
      } @else {
        <span i18n="@@catalogMap.sellersInResult">{{ sellerCount() }} Anbieter mit Treffern · Karte bewegen sucht neu</span>
      }
    </p>
  }
</section>
